const $$splitComponentImporter = () => import('/src/src/routes/_cms/cms/manage/communications/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_cms/cms/manage/communications/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Draft Communication Distributions",
      description: "Page title for the draft distribution on the cms"
    })
  }
});